// extracted by mini-css-extract-plugin
module.exports = {"debts__footer":"CashierDebts_debts__footer__2Z5E1","debts__footer__money":"CashierDebts_debts__footer__money__vhee0"};